import { gql } from '@apollo/client';
import type { FleetGeofenceRecommendation, RecommendationActionResult } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLGeofenceRecommendationsRequester {
  /** Lê o que o job persistiu. A geração saiu do caminho de request (AE-2756). */
  public getFleetGeofenceRecommendations = (fleetId: string): Promise<FleetGeofenceRecommendation[]> => {
    return graphQLRequester
      .query<{ fleetGeofenceRecommendations: FleetGeofenceRecommendation[]; errors?: Array<{ message: string }> }>({
        query: gql`
          query FleetGeofenceRecommendations($fleetId: ID!) {
            fleetGeofenceRecommendations(fleetId: $fleetId) {
              id
              fleetId
              name
              reason
              address
              color
              type
              area
              format
              radius
              longitude
              latitude
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL query errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.fleetGeofenceRecommendations;
      });
  };

  public completeFleetRecommendation = (fleetId: string, id: string): Promise<RecommendationActionResult> => {
    return graphQLRequester
      .mutate<{ completeFleetRecommendation: RecommendationActionResult; errors?: Array<{ message: string }> }>({
        mutation: gql`
          mutation CompleteFleetRecommendation($fleetId: ID!, $id: ID!) {
            completeFleetRecommendation(fleetId: $fleetId, category: "POIS", id: $id) {
              id
              fleetId
              finishedAt
              dismissedAt
              completedBy
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.completeFleetRecommendation;
      });
  };

  public dismissFleetRecommendation = (fleetId: string, id: string): Promise<RecommendationActionResult> => {
    return graphQLRequester
      .mutate<{ dismissFleetRecommendation: RecommendationActionResult; errors?: Array<{ message: string }> }>({
        mutation: gql`
          mutation DismissFleetRecommendation($fleetId: ID!, $id: ID!) {
            dismissFleetRecommendation(fleetId: $fleetId, category: "POIS", id: $id) {
              id
              fleetId
              finishedAt
              dismissedAt
              completedBy
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.dismissFleetRecommendation;
      });
  };
}

export default GraphQLGeofenceRecommendationsRequester;
